import { initializeApp } from "firebase/app";

import {
  getMessaging,
  getToken,
  onMessage,
} from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyAtSvgl9KkfpcPlh0X1EHRDvDFly2CI8Mo",
  authDomain: "liberte-solidaire.firebaseapp.com",
  projectId: "liberte-solidaire",
  storageBucket: "liberte-solidaire.firebasestorage.app",
  messagingSenderId: "417368848507",
  appId: "1:417368848507:web:3c3129d37560af1dfa8ade",
};

const app = initializeApp(firebaseConfig);

const messaging = getMessaging(app);

export {
  messaging,
  getToken,
  onMessage,
};